// testimonials.ts
export const testimonials = [
  {
    quote:
      "Our experience working with iCXeed has been really positive. Together, we’re developing some exciting AI-driven innovations on the AWS platform that are helping us take customer experience to the next level.",
    author: "Stefan Hutton",
    role: "Managing Director",
    company: "Scene to Believe",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/steffan-hutton.png",
  },
  {
    quote:
      "iCXeed has delivered Amazon Connect the way it's meant to be: rapid, iterative and cost-efficient. They're responsive, light on process and big on experimentation. This has generated real trust with the business and enabled me to build a cadence to deliver continuous improvement. That's the true sweet spot for agile.",
    author: "Hamish Stewart",
    role: "Director",
    company: "Flare Design",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/hamish-stewart.png",
  },
  {
    quote:
      "Our experience with iCXeed has been excellent. Their strong partnership with AWS, expertise in Amazon Connect, and customer-centric approach to change management are supporting the University of Melbourne's transition to a modern Contact Centre platform.",
    author: "Abhi Chaubey",
    role: "Senior Project Manager (CCaaS)",
    company: "The University of Melbourne",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/abhi-chaubey.png",
  },
  {
    quote:
      "Working with iCXeed has been a seamless and collaborative experience. Their team has consistently brought clarity and momentum to our AI and CX initiatives, project managing with precision and solving challenges proactively. Their support has been key to accelerating our innovation.",
    author: "Lucy Pickering",
    role: "Service Delivery Manager",
    company: "Sentral",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/lucy-pickering.png",
  },
  {
    quote:
      "We found throughout our search for an Amazon Connect partner that anyone can turn on a feature, but only iCXeed has been able to bridge the gap we have in Contact Centre expertise. They have challenged us to consider the customer journey and think outside the box, while also offering up innovative solutions to better our Contact Centre outcomes. And their passion is infectious!",
    author: "Mark Gwynne",
    role: "Chief Information Officer",
    company: "Australian Accident Management Commercial (AAMC)",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/mark-gwynne.png",
  },

  {
    quote:
      "Working with iCXeed has completely transformed our business - we have achieved more in the last 18 months together than we did in the 5 years prior. Our partnership has enhanced our customer experience through the use of analytics and automation, while also yielding operational efficiency gains. Arthur, Ryan & co are an integral part of our team; constantly going above and beyond to support our business goals.",
    author: "Jade McCarthy",
    role: "Head of Operations",
    company: "GlobalPay",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/jade-mccarthy.png",
  },
  {
    quote:
      "iCXeed was a natural addition to our growing business, providing simple and easy engagement, project management, and subject-matter experts who go out of their way for us. As a partner we chose for our Amazon Connect implementation, they've eliminated any fear or risk of impact, creating a 'so-what' feature that transforms our excellent capabilities into a platform for future innovation as we expand across other markets in a cost-effective, technology-smart way. This was about finding a partner who understood our vision and helped to deliver an omnichannel communication tool to promote excellence in customer service.",
    author: "James Baird",
    role: "VP Operational Excellence",
    company: "Fingermark",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/james-baird.png",
  },
  {
    quote:
      "Our experience with iCXeed has been nothing short of outstanding. They've transformed how we work with customers, giving us the right balance of power, usability, and scalability. iCXeed has been more than a technology partner; they’ve been true collaborators who care deeply about driving the right outcomes.",
    author: "Emma Dent",
    role: "Head of Corporate Operations",
    company: "Kip McGrath",
    image:
      "https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/emma-dent.png",
  },
];
